import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RuleCreateFormModel } from './rule-create.model';
import { SharedValidators } from '../../../../../../shared/validators/shared-validators';

export class RuleFormBuilder {
  public static createFormGroup(): FormGroup<RuleCreateFormModel> {
    const fg = new FormGroup<RuleCreateFormModel>({
      dataOd: new FormControl(null, [Validators.required]),
      dataDo: new FormControl({
        value: null,
        disabled: true,
      }),
      tresc: new FormControl(null, [Validators.required,SharedValidators.requiredTextWhichIsNotOnlyEmptyHtml()]),
      dataUtworzenia: new FormControl({
        value: new Date(),
        disabled: true,
      }),
    });
    return fg;
  }
}
